module.exports = __webpack_public_path__ + "img/im_scrollfeature_09.5c50a7f5.jpg";